
























































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { Floor, BuildingsApi, Property } from 'performo-api';
import { mapGetters } from 'vuex';
import { handleApiError } from '@/ApiHelpers';

@Component({
  components: {},
  computed: mapGetters({
    api: 'buildingsApi'
  })
})
export default class FloorPicker extends Vue {
  @Prop({ required: false, default: 'floor-picker' })
  private id?: string;

  @Prop({ required: false, type: Boolean, default: false })
  private required?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideAll?: boolean;

  @Prop({ required: false, type: Boolean, default: false })
  private hideLabel?: boolean;

  @Prop({ required: true })
  private value!: string;

  @Prop({ required: false, default: undefined })
  private buildingCode!: string;

  @Prop({ required: false, default: 'Floor' })
  private labelOverride?: string;

  @Prop({ required: false, type: String })
  private intendedValue?: string;

  get getValue() {
    return this.value;
  }
  get floorLabel() {
    return this.$store.state.currentProperty.floorLabel
      ? this.$store.state.currentProperty.floorLabel
      : this.labelOverride;
  }

  private api!: BuildingsApi;
  private floors: Floor[] = [];
  private loadingFloors = false;
  private hasMounted = false;
  private property: Property = {};

  // make sure the component input is updated if intendedValue is used
  @Watch('intendedValue')
  private async intendedValueChanged() {
    this.$emit('input', this.intendedValue);
  }

  @Watch('buildingCode')
  private async loadFloors() {
    try {
      this.loadingFloors = true;
      if (this.hasMounted) {
        this.$emit('input', '');
      }
      this.floors = [];
      if (this.buildingCode) {
        this.floors = await this.api.getFloorsByBuildingCode({
          buildingCode: this.buildingCode
        });
      }
      if (this.intendedValue) {
        this.$emit('input', this.intendedValue);
      }
    } catch (error) {
      handleApiError(error);
    } finally {
      this.loadingFloors = false;
    }
  }

  private async mounted() {
    if (this.buildingCode) {
      await this.loadFloors();
    } else {
      this.floors = [];
    }
    this.hasMounted = true;
  }

  public floorListContains(floorCode: string) {
    let found = false;
    this.floors.forEach((element) => {
      if (element.floorCode === floorCode) {
        found = true;
      }
    });
    return found;
  }
}
